import Popup from '@Components/Popups/Popup'
import React from 'react'
import Button from '@Components/Buttons/Button'
import './index.scss'

interface RegistrationCompletePopupProps {
    closePopup: () => void
}

const RegistrationCompletePopup = (props: RegistrationCompletePopupProps) => {
    const { closePopup } = props

    return (
        <Popup onClose={closePopup} showClose>
            <div className="registration-complete-popup">
                <p>
                    The next step is verifying and processing your submission. To view the status of your submission,
                    navigate to your profile by clicking the Back to Profile button.
                </p>
                <p>
                    When verification is completed, you will be notified via email with next steps for your account.
                    This usually take 1-3 business days.
                </p>
                <Button mainColor type="secondary" onClick={closePopup}>
                    Back to Profile
                </Button>
            </div>
        </Popup>
    )
}

export default RegistrationCompletePopup
